exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#visitor_info {\r\n  position: fixed;\r\n  bottom: 20px;\r\n  right: 20px;\r\n}\r\n\r\n.visitor-info-btn {\r\n  background-color: #85baac;\r\n  color: #fff;\r\n  font-weight: bold;\r\n  border: solid 2px #85baac;\r\n  -webkit-box-shadow: 0 1px 6px 2px rgba(0,0,0,.3);\r\n  box-shadow: 0 1px 6px 2px rgba(0,0,0,.3);\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/anach/Desktop/tengtu-website/src/app/components/home/home/home.component.css
// module id = ../../../../../src/app/components/home/home/home.component.css
// module chunks = main